import { render } from "./RelatedArticles.vue?vue&type=template&id=4db1ba00&scoped=true"
import script from "./RelatedArticles.vue?vue&type=script&lang=js"
export * from "./RelatedArticles.vue?vue&type=script&lang=js"

import "./RelatedArticles.vue?vue&type=style&index=0&id=4db1ba00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db1ba00"]])

export default __exports__